// extracted by mini-css-extract-plugin
export default {"arrow":"LayerGroupArrow_arrow__xNF6J"};